.anonLayout {
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
}

.anonEditorWrapper {
	position: relative;
	width: 100%;
	height: 100%;
	flex-grow: 2;
	overflow: hidden;
}
